'use client'

import React from 'react'
import { useAnimateOnVisible } from '@hooks/useAnimateOnVisible'
import { CustomerStoryDescriptionMock } from '@components/CustomerStory/CustomerStoryMock'
import styles from './CustomerStoryDescription.module.scss'

const CustomerStoryDescription = () => {
  const { ref: titleRef, animationClassName: titleClass } = useAnimateOnVisible<HTMLParagraphElement>()
  const { ref: descRef, animationClassName: descClass } = useAnimateOnVisible<HTMLParagraphElement>({
    animationDelayMs: 60,
  })
  return (
    <div className={styles.customerStoryDescriptionContainer}>
      <p ref={titleRef} className={`${styles.customerStoryTitle} ${titleClass}`}>
        {CustomerStoryDescriptionMock.title}
      </p>
      <p ref={descRef} className={`${styles.customerStoryDescription} ${descClass}`}>
        {CustomerStoryDescriptionMock.description}
      </p>
    </div>
  )
}

export default CustomerStoryDescription
